<template>
    <div class="engine">
        <div class="label">
          {{ $t('common.modals.create_external.engines.aws-comprehend.awsComprehendSettings') }}
        </div>

        <div class="engine--description">
          {{ $t('common.modals.create_external.engines.aws-comprehend.readMoreAbout') }}
          <a class="engine--info-url" :href="awsUrl" target="_blank">
            {{ $t('common.modals.create_external.engines.aws-comprehend.here') }}
          </a>
        </div>

        <or-textbox
            v-model="localAwsComprehendModel.settings.endpointArn"
            :label="$t('common.modals.create_external.engines.aws-comprehend.endpointArn')"
            :placeholder="$t('common.modals.create_external.engines.aws-comprehend.endpointArn')"
        />

        <or-textbox
            v-model="localAwsComprehendModel.settings.accessKeyId"
            :label="$t('common.modals.create_external.engines.aws-comprehend.accessKeyId')"
            :placeholder="$t('common.modals.create_external.engines.aws-comprehend.enterAccessKeyId')"
        />

        <or-textbox
            v-model="localAwsComprehendModel.settings.secretAccessKey"
            :label="$t('common.modals.create_external.engines.aws-comprehend.secretAccessKey')"
            :placeholder="$t('common.modals.create_external.engines.aws-comprehend.enterSecretAccessKey')"
        />

        <or-textbox
            v-model="localAwsComprehendModel.settings.region"
            :label="$t('common.modals.create_external.engines.aws-comprehend.region')"
            :placeholder="$t('common.modals.create_external.engines.aws-comprehend.enterRegion')"
        />
    </div>
</template>

<script>
import { AWS_COMPREHEND_DOCS_URL } from '@/config'

export const getAwsComprehendDefaultSettings = () => ({
  endpointArn: '',
  accessKeyId: '',
  secretAccessKey: '',
  region: ''
})

export default {
  props: {
    awsComprehendModel: {
      settings: {
        endpointArn: String,
        accessKeyId: String,
        secretAccessKey: String,
        region: String
      }
    },
    errors: {
      settings: {}
    }
  },

  computed: {
    localAwsComprehendModel: {
      get () {
        return this.$props.awsComprehendModel
      },
      set (value) {
        this.$emit('update:awsComprehendModel', value)
      }
    }
  },

  data () {
    return {
      awsUrl: AWS_COMPREHEND_DOCS_URL
    }
  }
}
</script>

<style scoped>

</style>
